import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#E5E0D8] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="font-serif-display text-3xl text-stone-900">BrushBasics</div>
          <p className="mt-3 text-sm text-stone-500 leading-relaxed max-w-xs">
            An editorial guide to every brush in your kit — what it does, why it matters, and how to use it.
          </p>
        </div>
        <div>
          <div className="overline mb-4">Explore</div>
          <ul className="space-y-2 text-sm text-stone-600">
            <li><Link className="hover:text-stone-900" to="/catalog">The Catalog</Link></li>
            <li><Link className="hover:text-stone-900" to="/quiz">Brush Finder Quiz</Link></li>
            <li><Link className="hover:text-stone-900" to="/blog">The Journal</Link></li>
            <li><Link className="hover:text-stone-900" to="/about">About BrushBasics</Link></li>
            <li><Link className="hover:text-stone-900" to="/return-policy" data-testid="footer-return-policy">Return Policy & Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Editorial Note</div>
          <p className="text-sm text-stone-500 leading-relaxed">
            Every brush in this guide is curated for technique and intent — not for sponsorship. Built with care for the everyday makeup lover.
          </p>
        </div>
      </div>
      <div className="border-t border-[#E5E0D8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs text-stone-500 flex justify-between">
          <span>© {new Date().getFullYear()} BrushBasics</span>
          <span className="overline">Crafted Editorially</span>
        </div>
      </div>
    </footer>
  );
}
